export const JIRA_API_ERRORS_STATUSES_TO_TEXT_KEYS = {
	'404': 'txt_wrong_jira_host',
	'401': 'txt_wrong_jira_user_credentials',
	'400': 'txt_wrong_jira_user_credentials',
};
